import { Controller } from "@hotwired/stimulus"

// Асинхронный возврат палеты (форма return_modal, multipart: reason + файл).
// Успех: полная перезагрузка страницы (проще, чем патчить строку таблицы).
// Ошибка (422): сообщения показываются внутри попапа, без перезагрузки.
export default class extends Controller {
  static targets = ["modal", "form", "errors"]

  submit(event) {
    event.preventDefault()
    this.clearErrors()
    const form = this.formTarget
    const btn = form.querySelector('[type="submit"]')
    if (btn) btn.disabled = true
    fetch(form.action, {
      method: "PATCH",
      body: new FormData(form),
      headers: { "Accept": "application/json", "X-CSRF-Token": this.csrfToken }
    }).then(async (res) => {
      const data = await res.json().catch(() => ({}))
      if (res.ok) { window.location.reload() }
      else { this.showErrors(data.errors || ["Не удалось оформить возврат."]) }
    }).catch(() => this.showErrors(["Ошибка сети."]))
      .finally(() => { if (btn) btn.disabled = false })
  }

  showErrors(msgs) {
    this.errorsTarget.classList.remove("d-none")
    this.errorsTarget.innerHTML = "<ul class='mb-0'>" + msgs.map(m => `<li>${m}</li>`).join("") + "</ul>"
  }
  clearErrors() { this.errorsTarget.classList.add("d-none"); this.errorsTarget.innerHTML = "" }
  get csrfToken() { return document.querySelector('meta[name="csrf-token"]')?.content }
}
